// extracted by mini-css-extract-plugin
module.exports = {"root":"PhotosGrid_root__pNJkU","item":"PhotosGrid_item__1Jl38","image":"PhotosGrid_image__SUyrC"};